export function deepClone<T>(c: T): T {
    try {
        return structuredClone(c);
    } catch {
        return JSON.parse(JSON.stringify(c));
    }
}
